import { render, staticRenderFns } from "./StartsCreditPackageMT.vue?vue&type=template&id=ac47b756&scoped=true&"
import script from "./StartsCreditPackageMT.vue?vue&type=script&lang=js&"
export * from "./StartsCreditPackageMT.vue?vue&type=script&lang=js&"
import style0 from "./StartsCreditPackageMT.vue?vue&type=style&index=0&id=ac47b756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac47b756",
  null
  
)

export default component.exports